import React from "react";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import useDash from "../../assets/css/dash.module.css";
import { tutorialLink } from "./tutorialLink";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Tutorial = () => {
  const { t } = useTranslation();

  const userRole = useSelector((state) => state.persistedReducer.auth?.role);
  return (
    <>
      <Sidebar />
      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            {tutorialLink?.length > 0 ? (
              <div className="displayGrid3">
                {tutorialLink?.map((item) => {
                  return (
                    (userRole === item.role || item.role === "") && (
                      <div className="embed-responsive">
                        <iframe
                          width="400"
                          height="250"
                          src={item.link}
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen=""
                          title="Embedded youtube"
                          className="embed-responsive-item"
                        />
                        <label className="form-label" htmlFor="">
                          {item.title}
                        </label>
                      </div>
                    )
                  );
                })}
              </div>
            ) : (
              <h5 className="text-center">{t("noDataFound")}</h5>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Tutorial;
